

import axios from '@/libs/api.request';

export const getLogList = data => {
    return axios.request({
        url: 'api/systemManagement/log/list',
        data: data,
        method: 'post'
    });
};
export const getColumnDescList = data => {
    return axios.request({
        url: 'api/systemManagement/columnDesc/list',
        data: data,
        method: 'post'
    });
};
export const saveColumnDesc = data => {
    return axios.request({
        url: 'api/systemManagement/columnDesc/save',
        data: data,
        method: 'post'
    });
};


